import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=a8e4f2ce&scoped=true"
import script from "./ConfigurationModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationModal.vue?vue&type=style&index=0&id=a8e4f2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e4f2ce",
  null
  
)

export default component.exports